<template>
  <div class="chart-card" :class="{ 'chart-card--full': full }">
    <div class="chart-card__title">{{ title }}</div>
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ChartCard',
  props: {
    title: { type: String, required: true },
    full: { type: Boolean, default: false },
  },
});
</script>

<style lang="scss" scoped>
.chart-card {
  padding: 12px;
  background: $color-surface-muted;
  border-radius: $border-radius-sm;

  &__title {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 600;
    color: $color-text-secondary;
  }

  &__empty {
    padding: 60px 0;
    font-size: 12px;
    text-align: center;
    color: $color-text-secondary;
  }

  &--full {
    grid-column: 1 / -1;
  }

  ::v-deep .chart-card__empty {
    padding: 60px 0;
    font-size: 12px;
    text-align: center;
    color: $color-text-secondary;
  }
}
</style>
